import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store  from './store';
import { Provider } from 'react-redux';
import Hotjar from './helpers/Hotjar';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      { process.env.REACT_APP_ENV !== "local" && <Hotjar /> }
      <App />
    </React.StrictMode>
  </Provider>
);

reportWebVitals();
